const types = {
    BACKGROUND_AUDIO_RESTORE_AUDIO_STATUS: 'BACKGROUND_AUDIO_RESTORE_AUDIO_STATUS',
    BACKGROUND_AUDIO_SET_INTRO_PLAYED: 'BACKGROUND_AUDIO_SET_INTRO_PLAYED',
    BACKGROUND_AUDIO_SET_SECTION_POSITION: 'BACKGROUND_AUDIO_SET_SECTION_POSITION',
    BACKGROUND_AUDIO_SET_SECTION_STATUS: 'BACKGROUND_AUDIO_SET_SECTION_STATUS',
    BACKGROUND_AUDIO_SET_TIMES_REPLAY_REQUESTED: 'BACKGROUND_AUDIO_SET_TIMES_REPLAY_REQUESTED',
    BACKGROUND_AUDIO_SET_RECENT_PLAYING_AUDIO: 'BACKGROUND_AUDIO_SET_RECENT_PLAYING_AUDIO',
};

const backgroundAudioActions = {
    types,

    restoreAudioStatus(backgroundAudio) {
        return { type: this.types.BACKGROUND_AUDIO_RESTORE_AUDIO_STATUS, backgroundAudio };
    },

    setSectionAudioStatus(audioContentItemId, status) {
        return { type: this.types.BACKGROUND_AUDIO_SET_SECTION_STATUS, audioContentItemId, status };
    },

    setIntroPlayed(isIntroPlayed) {
        return { type: this.types.BACKGROUND_AUDIO_SET_INTRO_PLAYED, isIntroPlayed };
    },

    setSectionAudioPosition(audioContentItemId, position) {
        return { type: this.types.BACKGROUND_AUDIO_SET_SECTION_POSITION, audioContentItemId, position };
    },

    setSectionAudioTimesReplayRequested(audioContentItemId, timesReplayRequested) {
        return { type: this.types.BACKGROUND_AUDIO_SET_TIMES_REPLAY_REQUESTED, audioContentItemId, timesReplayRequested };
    },

    setRecentPlayingAudio(audioContentItemId) {
        return { type: this.types.BACKGROUND_AUDIO_SET_RECENT_PLAYING_AUDIO, audioContentItemId };
    },
};

export default backgroundAudioActions;
